import React, { useState } from 'react';
import { Divider, IconButton, Menu, MenuItem } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';

// Column header menu in the Wizard enquiry style: optional status filters, then sort ascending / descending
const DateSortMenu = ({ order, onChange, ariaLabel = 'Sort', statusOptions, statusValue, onStatusChange }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const showStatus = Boolean(statusOptions?.length && onStatusChange);

    const close = () => setAnchorEl(null);

    const handleSort = (value) => {
        close();
        if (value !== order) onChange(value);
    };

    const handleStatus = (value) => {
        close();
        onStatusChange(value);
    };

    return (
        <>
            <IconButton
                aria-label={ariaLabel}
                onClick={(event) => { event.stopPropagation(); setAnchorEl(event.currentTarget); }}
            >
                <ArrowDropDown sx={{ color: order || (showStatus && statusValue) ? '#512DA8' : 'inherit' }} />
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
                {showStatus && [
                    <MenuItem key="all" onClick={() => handleStatus('')}>
                        All statuses{!statusValue ? ' ✓' : ''}
                    </MenuItem>,
                    ...statusOptions.map((option) => (
                        <MenuItem key={option.value} onClick={() => handleStatus(option.value)}>
                            {option.label}{statusValue === option.value ? ' ✓' : ''}
                        </MenuItem>
                    )),
                    <Divider key="divider" />,
                ]}
                <MenuItem onClick={() => handleSort('asc')}>
                    Sort ascending{order === 'asc' ? ' ✓' : ''}
                </MenuItem>
                <MenuItem onClick={() => handleSort('desc')}>
                    Sort descending{order === 'desc' ? ' ✓' : ''}
                </MenuItem>
            </Menu>
        </>
    );
};

export default DateSortMenu;
